export const ErrorNRLogs = {
  webFetchError: 'web_fetch_error',
  webGetFetchError: 'web_get_fetch_error',
  webFetchPostError: 'web_fetch_post_error',
  webFetchPostWithFormDataError: 'web_fetch_post_with_form_data_error',

  // Individual API logs
  webFnoPositionAPIError: 'web_fno_position_api_error',
}
